import type { GameMode } from '@/state/types';

/**
 * Block B / B6 — Punktesystem.
 * Sandbox vergibt keine Punkte für Kauf-Aktionen, sonst identisch.
 */

export type PointAction =
  | 'missionSuccess'
  | 'missionFailure'
  | 'newVehicle'
  | 'newStation';

export const POINTS_BY_ACTION: Record<PointAction, Record<GameMode, number>> = {
  missionSuccess: { normal: 1, realistic: 1, sandbox: 1 },
  missionFailure: { normal: -1, realistic: -1, sandbox: -1 },
  newVehicle: { normal: 1, realistic: 1, sandbox: 0 },
  newStation: { normal: 1, realistic: 1, sandbox: 0 },
};

export function pointsFor(action: PointAction, mode: GameMode): number {
  return POINTS_BY_ACTION[action][mode];
}
